// extracted by mini-css-extract-plugin
module.exports = {"segmentListLetterHeader":"SegmentListItemsHeader_segmentListLetterHeader__30ODg"};